/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from "lodash-es";
import React, { useEffect, useState } from "react";
import Form from "../../components/Form";
import Modal, { ModalHeader } from "../../components/Modal";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import { ANONYMOUS, NOTICE } from "../../constants/COMMUNITY";
import { addCommunityPost, modifyCommunityPost, getCommunityPost } from "../../apis/community/communityBoard";
import { getFormatDateHour, hasInRange } from "../../utils/date";
import Comment from "../../components/Comment";
import { useSelector } from "react-redux";
// import useForm from "../../hooks/useForm";

const DetailCommunityPost = (props) => {
  const { community, post, open, setOpen, setPost, submit, permission, orgMode } = props
  const { employee } = useSelector((store) => ({
    employee: store.Profile.employee,
  }));
  const [mode, setMode] = useState(orgMode)
  const [fields, setFields] = useState([]);
  const [buttons, setButtons] = useState([])
  const [isCanEdit, setIsCanEdit] = useState(false)
  const defaultForm = {
    title: "",// 제목
    content: "", // 내용
    isTop: '0',
    topStartTime: null,
    topEndTime: null,
    isAnonymous: "0",
    fileIdxes: []
  }

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    resetForm(defaultForm)
    setPost(null)
  };

  const _submit = ({
    isAnonymous, isTop,
    topStartTime, topEndTime,
    ..._form }) => {

    const form = {
      ..._form,
      isAnonymous: isAnonymous === "1",
      isTop: isTop === "1",
      topStartTime: isTop === "1" && !isEmpty(topStartTime) ? topStartTime[0] : null,
      topEndTime: isTop === "1" && !isEmpty(topEndTime) ? topEndTime[0] : null,
    }

    if (mode === "create") {
      systemAlert(`"${form.title}" 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '등록',
            onClick: () => {
              addCommunityPost(community.idx, form)
                .then(() => {
                  cancel()
                  if (submit) {
                    submit()
                  }
                })
            }
          }
        ]
      })
    } else if (mode === "modify") {
      systemAlert(`"${form.title}" 수정하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              modifyCommunityPost(community.idx, post.idx, form)
                .then(() => {
                  cancel()
                  if (submit) {
                    submit()
                  }
                })
            }
          }
        ]
      })
    }
    

  }

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    resetForm,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    setMode(orgMode)
    // setFormFields(task.fields)
    // debugger
    if (post) {
      const form = {
        ...post,
        isAnonymous: post.isAnonymous ? "1" : "0",
        isTop: post.isTop ? "1" : "0",
        fileIdxes: post.uploadFiles
      }
      setForm(form)
      setOriginForm(form)
    } else {
      setForm({
        ...defaultForm,
        isAnonymous: community.isAnonymous ? "1" : "0"
      })
      setOriginForm({
        ...defaultForm,
        isAnonymous: community.isAnonymous ? "1" : "0"
      })
    }
  }, [open, post, orgMode])

  useEffect(() => {
    setFields([

      [
        {
          isHide: mode === 'view' || permission.level <= 2,
          title: "공지사항",
          key: "isTop",
          type: "radio",
          options: {
            list: NOTICE,
          },
          required: true,
        },

      ],

      [
        {
          isHide: ({ form }) => mode === 'view' || permission.level <= 2 || form.isTop === '0',
          title: "공지사항 시작",
          key: "topStartTime",
          type: "datetimepicker",
        },
        {
          isHide: ({ form }) => mode === 'view' || permission.level <= 2 || form.isTop === '0',
          title: "공지사항 종료",
          key: "topEndTime",
          type: "datetimepicker",
        },
      ],
      [
        {
          isHide: mode === 'view' || !community.isAnonymous,
          title: "실명/익명",
          key: "isAnonymous",
          type: "radio",
          options: {
            list: ANONYMOUS,
          },
          required: true,
        },

      ],
      [
        {
          isHide: mode !== 'view',
          title: mode !== 'view' && "작성자", key: "writerEmployeeIdx", type: "profile",
          className: 'mt-10'
        },
        {
          isHide: mode !== 'view',
          title: mode !== 'view' && "작성일시", key: "createdTime",
          className: 'text-align-right color-gray-5',
          onValue: (data, fields, datas) => {
            return `작성일 : ${getFormatDateHour(data)}   조회 : ${datas.viewCount}`
          }
          // onValue: (data, fields, { createdTime, updatedTime, viewCount }) => {
          //   const isUpdate = getFormatDateHour(createdTime) !== getFormatDateHour(updatedTime)
          //   console.log(getFormatDateHour(createdTime) !== getFormatDateHour(updatedTime))
          //   console.log(getFormatDateHour(createdTime), getFormatDateHour(updatedTime))
          //   debugger
          //   return `작성일 : ${getFormatDateHour(data)}${isUpdate ? ` 수정일 : ${getFormatDateHour(data)}` : ''}   조회 : ${viewCount}`
          // }
        },
      ],
      {
        isHide: mode !== 'view',
        type: 'line'
      },
      [
        {
          isHide: mode === 'view',
          title: "제목", key: "title", type: "input", required: true, readOnly: mode === "modify" ? true : false
        },
      ],
      [
        {
          className: 'min-heihgt-200',
          title: mode !== 'view' && "내용", key: "content", type: "editor", required: true,
        },
      ],
      {
        isHide: mode !== 'view',
        type: 'line'
      },
      [
        {
          title: "첨부파일",
          key: "fileIdxes",
          type: "dropzone",
        },
      ],
      {
        isHide: mode !== 'view',
        type: "reaction",
        params: {
          postIdx: "idx",
          postType: "community_board"
        },
        fullWidth: true
      },
    ])

    if (mode === 'view' && community && post) {
      getCommunityPost(community.idx, post.idx)
        .then((data) => {
          setIsCanEdit(data.data.writerEmployeeIdx === employee.employeeIdx)
        })
    }
  }, [mode])

  useEffect(() => {
    setButtons([
      {
        color: 'text',
        label: '닫기',
        onClick: cancel
      },
      {
        isHide: mode !== 'modify',
        label: '수정',
        onClick: handleSubmit
      },
      {
        isHide: mode !== 'create',
        label: '글쓰기',
        onClick: handleSubmit
      }
    ])
  }, [mode, isCanEdit])
  useEffect(() => {
    setValidateFields(fields)
  }, [fields])

  return (
    <Modal
      isOpen={open}
      // isOpen={true}
      close={cancel}
    // {...mode === 'create' ? { close: cancel } : { toggle: cancel }}
    >
      <div className="client-write">
        <ModalHeader>{post ? <>{post.isTop && hasInRange(post.topStartTime, post.topEndTime) ? '[공지] ' : ''}{post.title}</> : '글쓰기'} </ModalHeader>
        {post && post.isTop ? <div>
          공지기간 : {post.topStartTime ? getFormatDateHour(post.topStartTime) + '부터 ' : ''}
          {post.topEndTime ? getFormatDateHour(post.topEndTime) + '까지' : ''}
        </div> : <></>}
        <Form
          mode={mode}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          // submitText={mode === 'create' ? '작성' : '수정'}
          // submit={handleSubmit}
          // cancel={cancel}
          buttons={buttons}
        >
          {mode === 'view' && post && (
            <div className="file-upload-list">
              {/* <label className="file-upload-label"></label> */}
              <div className="file-upload-form">
                <Comment
                  postIdx={post.idx}
                  postType="community"
                  submit={submit}
                  isFirstSubmit={false}
                  isAnonymous={post.isAnonymous}
                  param={{communityIdx: community.idx, title: post.title}}
                />
              </div>
            </div>
          )}
        </Form>

      </div>
    </Modal>
  );
};

export default DetailCommunityPost;
